/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei';

export function LamellaReady(props) {
  const { nodes, materials } = useGLTF('/lamellaReady.glb');
  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cube.geometry} position={props.position} material={materials['Material.002']} scale={props.scale} rotation={[0, props.rotation, 0]} />
    </group>
  );
}

useGLTF.preload('/lamellaReady.glb');
